import { FacebookFormConfiguration } from "src/app/core/models/social-forms-configurations/facebook-form-configuration.model"
import { FacebookFormConfigurationCreateDto } from "src/app/infrastructure/lobby-proxy/DTOs/facebook-form-configuration-create.dto"
import { FacebookFormConfigurationUpdateDto } from "src/app/infrastructure/lobby-proxy/DTOs/facebook-form-configuration-update.dto"
import { FacebookConfigurationDto } from "src/app/infrastructure/lobby-proxy/DTOs/facebook-form-configuration.dto"
import { LeadInjectorDtoToLeadInjector } from "../lead-model-dto/lead-injector.mapping"

export function facebookConfigurationDtoToFacebookForm(source: FacebookConfigurationDto): FacebookFormConfiguration | null {
    if (!source) return null
    return {
        id: source.id,
        formId: source.formId,
        formName: source.formName,
        created: source.created,
        updated: source.updated,
        isEnabled: source.isEnabled,
        formDescription: source.formDescription,
        injector: LeadInjectorDtoToLeadInjector(source.injector)
    } as FacebookFormConfiguration
}

export function facebookConfigurationTofacebookConfigurationUpdateDto(source: FacebookFormConfiguration): FacebookFormConfigurationUpdateDto | null {
    if (!source) return null
    return {
        isEnabled: source.isEnabled,
        formName: source.formName,
        formDescription: source.formDescription,
        leadInjectorId: source.injector!.id,
        formId: source.formId
    } as FacebookFormConfigurationUpdateDto
}

export function facebookConfigurationTofacebookConfigurationCreateDto(source: FacebookFormConfiguration): FacebookFormConfigurationCreateDto | null {
    if (!source) return null
    return {
        leadInjectorId: source.injector!.id,
        formId: source.formId,
        formName: source.formName,
        formDescription: source.formDescription
    } as FacebookFormConfigurationCreateDto
}